var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-click-to-dial"},[_c('div',{staticClass:"click-to-dial ma-2"},[_c('click-to-dial')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }